/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagingDTO } from './paging-dto';
import { OrganizationWithStatusLogDTO } from './organization-with-status-log-dto';


/**
 * Array of Organization with status log results filtered, ordered and with paging support
 */
export interface OrganizationWithStatusLogResultResponseDTO { 
    results: Array<OrganizationWithStatusLogDTO>;
    paging: PagingDTO;
}

export class ClsOrganizationWithStatusLogResultResponseDTO { 
    results: Array<OrganizationWithStatusLogDTO> = undefined;
    paging: PagingDTO = undefined;
}

